import apiClient from './api';

/** Kiosk ads — the posters and clips one BRANCH plays on its attract screen. */
const path = (restaurantId, locationId, id) =>
  `/users/restaurant/${restaurantId}/locations/${locationId}/kiosk-ads/${id ? `${id}/` : ''}`;

export const kioskAdsService = {
  /** Every ad this branch has, on and off, in the order they play. */
  list: async (restaurantId, locationId) => {
    const { data } = await apiClient.get(path(restaurantId, locationId));
    return { ads: data?.data || [], limits: data?.limits || {} };
  },

  /** One file. The server decides from its type whether it is a poster or a clip. */
  upload: async (restaurantId, locationId, file) => {
    const fd = new FormData();
    fd.append('media', file);
    const { data } = await apiClient.post(path(restaurantId, locationId), fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data?.data;
  },

  /** Turn one off without losing it — a seasonal poster comes back next year. */
  setActive: async (restaurantId, locationId, id, isActive) => {
    const { data } = await apiClient.patch(path(restaurantId, locationId, id),
      { is_active: isActive });
    return data?.data;
  },

  remove: async (restaurantId, locationId, id) => {
    await apiClient.delete(path(restaurantId, locationId, id));
  },
};

/** The branch's kiosk clock — seconds without a touch before "Still there?",
    and the countdown after it — set under Settings → Kiosk Settings. */
const settingsPath = (restaurantId, locationId) =>
  `/users/restaurant/${restaurantId}/locations/${locationId}/kiosk-settings/`;

export const kioskSettingsService = {
  /** { idle_seconds, countdown_seconds, limits } as the server holds them. */
  get: async (restaurantId, locationId) => {
    const { data } = await apiClient.get(settingsPath(restaurantId, locationId));
    return data?.data || {};
  },

  /** Either or both numbers; the server validates the range and echoes the result. */
  save: async (restaurantId, locationId, payload) => {
    const { data } = await apiClient.patch(settingsPath(restaurantId, locationId), payload);
    return data?.data || {};
  },
};

export default kioskAdsService;
